import API, { baseURL } from './api';
import { getSucursalInfo } from './auth';

// Ported from sge_infantil_web/src/pages/teacher/{create,list}/index.js.
// teacher/edit/index.js in the original is dead/broken code (copy-pasted
// from the student module, hits /api/student/... by mistake) — the real
// edit endpoint is the one used by list/index.js's inline edit modal.
export async function listTeachers() {
  const sucursalId = getSucursalInfo()?.id || 1;
  const resp = await API.get(`${baseURL}api/teacher/${sucursalId}`);
  return resp;
}

export async function createTeacher(payload) {
  return API.post(`${baseURL}api/teacher`, payload);
}

export async function updateTeacher(id, payload) {
  return API.put(`${baseURL}api/teacher/${id}`, payload);
}

export async function deleteTeacher(id, removedBy) {
  return API.delete(`${baseURL}api/teacher/remove/${id}`, { data: { removedBy } });
}

export async function listFrequencies() {
  const sucursalId = getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/frequency/${sucursalId}`);
}

export async function listSubjectsByLevel(levelId) {
  const sucursalId = getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/subjects/${sucursalId}?levelId=${levelId}`);
}
